import PhotoMotion from '@/components/feature/PhotoMotion';
import { cdn } from '@/config/cdn';

function Label({ n, title, note }: { n: string; title: string; note: string }) {
  return (
    <div className="mt-4 flex items-baseline gap-4">
      <span className="fold-label text-[rgba(245,241,235,0.5)] tabular-nums">{n}</span>
      <div className="min-w-0">
        <h3 className="fold-serif text-[20px] md:text-[24px] leading-tight">{title}</h3>
        <p className="mt-1 text-[14px] leading-relaxed text-[rgba(245,241,235,0.6)]">{note}</p>
      </div>
    </div>
  );
}

export default function Process() {
  return (
    <section className="bg-[#171515] text-[#F5F1EB] py-20 md:py-32" aria-labelledby="process-heading">
      <div className="fold-shell">
        <div className="flex items-baseline justify-between gap-6 border-b border-[rgba(245,241,235,0.14)] pb-5">
          <h2 id="process-heading" className="fold-label text-[rgba(245,241,235,0.6)]">03 — The Process</h2>
          <p className="fold-label text-[rgba(245,241,235,0.6)] hidden sm:block">Fold, rest, bake</p>
        </div>

        <div className="mt-12 md:mt-20 grid grid-cols-1 md:grid-cols-12 gap-y-14 md:gap-x-8">
          <figure className="md:col-span-7 lg:col-span-6 min-w-0">
            <div className="w-full aspect-[4/5] overflow-hidden bg-[#0f0e0e]">
              <PhotoMotion fromScale={1.06} fromY={28} duration={1.2} parallax={24}>
              <img
                src={cdn('https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_story-process-fold.webp')}
                alt="Baker folding croissant dough on a marble bench"
                title="The Fold — FOLD. Artisan Bakery"
                className="w-full h-full object-cover object-[50%_40%]"
              />
              </PhotoMotion>
            </div>
            <Label n="01" title="The Fold" note="Butter and dough, turned and folded by hand until the layers hold." />
          </figure>

          <figure className="md:col-span-5 lg:col-span-4 lg:col-start-8 min-w-0 md:self-end">
            <div className="w-full aspect-square overflow-hidden bg-[#0f0e0e]">
              <PhotoMotion delay={0.16} fromScale={1.045} fromY={18} duration={1.05} parallax={12}>
              <img
                src={cdn('https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_story-process-rest.webp')}
                alt="Raw laminated dough showing stacked butter layers"
                title="The Rest — FOLD. Artisan Bakery"
                className="w-full h-full object-cover object-center"
              />
              </PhotoMotion>
            </div>
            <Label n="02" title="The Rest" note="Cold, quiet hours between each turn. Nothing to do but wait." />
          </figure>

          <figure className="md:col-span-12 lg:col-span-10 lg:col-start-3 min-w-0">
            <div className="w-full aspect-[4/3] sm:aspect-[21/9] overflow-hidden bg-[#0f0e0e]">
              <PhotoMotion delay={0.05} fromScale={1.05} fromY={20} duration={1.25} parallax={20}>
              <img
                src={cdn('https://public.readdy.ai/ai/img_res/sandbox/3f1aaab66cd17eb8c8e3638ae7fd21c0/dae56e5b-1236-4064-8146-226bddbfd4d4_story-process-bake.webp')}
                alt="Freshly baked croissants coming out of the oven"
                title="The Bake — FOLD. Artisan Bakery"
                className="w-full h-full object-cover object-[50%_55%]"
              />
              </PhotoMotion>
            </div>
            <Label n="03" title="The Bake" note="Into the oven at dawn, out when every layer has turned to gold." />
          </figure>
        </div>
      </div>
    </section>
  );
}